module.exports = __webpack_public_path__ + "img/9.b2b20cd4.jpg";